interface ISendGoogleAnalyticsData {
  organizationId?: string;
  organizationName?: string;
  path: string;
  projectId?: string;
  projectName?: string;
}

function sendGoogleAnalyticsData({
  organizationId = '',
  organizationName = '',
  path,
  projectId = '',
  projectName = '',
}: ISendGoogleAnalyticsData) {
  window.ga('send', 'event', {
    dimension1: organizationId,
    dimension2: organizationName,
    dimension3: projectId,
    dimension4: projectName,
    eventAction: 'changePage',
    eventCategory: 'routing',
    eventLabel: 'navigateToPage',
    page: path,
  });
}

export const GOOGLE_ANALYTICS_ACTION_NAMES = {
  SEND_EVENT: 'GOOGLE_ANALYTICS_ACTION_NAMES__SEND_EVENT',
};

export const googleAnalyticsMiddleware = () => (next) => (action) => {
  if (action.type === GOOGLE_ANALYTICS_ACTION_NAMES.SEND_EVENT) {
    sendGoogleAnalyticsData(action.payload);
  }

  return next(action);
};
